module.exports = __webpack_public_path__ + "../resources/img/ic_re_fog_solid.d531a6e1.svg";